import { drilldownData, ModuleFields } from "@utils/drilldownData";

export const fields: any = {
  grandchildheader: drilldownData["grandchildheader"]?.map(
    ({
      fieldName,
      fieldValue,
      placeholder,
      name,
      formType,
      validation,
      className,
      loadOptions,
      options,
      usedFileType,
      note,
      uploadTrigger,
    }: ModuleFields) => ({
      name: name,
      fieldValue: fieldValue,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      options: options,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
      note: note,
      uploadTrigger: uploadTrigger,
    })
  ),

  childheaders: drilldownData["childheaders"]?.map(
    ({
      fieldName,
      fieldValue,
      placeholder,
      name,
      formType,
      validation,
      className,
      loadOptions,
      options,
      usedFileType,
      note,
      uploadTrigger,
    }: ModuleFields) => ({
      name: name,
      fieldValue: fieldValue,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      options: options,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
      note: note,
      uploadTrigger: uploadTrigger,
    })
  ),

  mainheaders: drilldownData["mainheaders"]?.map(
    ({
      fieldName,
      fieldValue,
      placeholder,
      name,
      formType,
      validation,
      className,
      loadOptions,
      options,
      usedFileType,
      note,
      uploadTrigger,
    }: ModuleFields) => ({
      name: name,
      fieldValue: fieldValue,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      options: options,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
      note: note,
      uploadTrigger: uploadTrigger,
    })
  ),

  cardheader: drilldownData["cardheader"]?.map(
    ({
      fieldName,
      fieldValue,
      placeholder,
      name,
      formType,
      validation,
      className,
      loadOptions,
      options,
      usedFileType,
      note,
      uploadTrigger,
    }: ModuleFields) => ({
      name: name,
      fieldValue: fieldValue,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      options: options,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
      note: note,
      uploadTrigger: uploadTrigger,
    })
  ),
};
